import * as yup from 'yup';

export const RoleSchema = yup.object({
  relationship_id: yup.string().nullable(),
  role_id: yup.string(),
  permission_ids: yup.array().of(yup.string()),
});
export type Role = yup.InferType<typeof RoleSchema>;

export const UserPermissionsSchema = yup.object({
  object_permissions: yup.object({
    roles: yup.array().of(RoleSchema),
    related_permissions: yup.array().of(yup.object()),
  }),
  user_id: yup.string(),
  user_type: yup.string(),
});
export type UserPermissions = yup.InferType<typeof UserPermissionsSchema>;

export enum BulkUserPermissionAction {
  CREATE = 'create',
  DELETE = 'delete',
}

export const ActionCreateUserPermissionRequestSchema = yup.object({
  action: yup
    .mixed<BulkUserPermissionAction>()
    .oneOf([BulkUserPermissionAction.CREATE]),
  value: yup.object({
    user_id: yup.string(),
    user_type: yup.string(),
    role_ids: yup.array().of(yup.string()).nullable(),
    role: yup
      .object({
        role_id: yup.string(),
        expiry: yup.string(),
      })
      .nullable(),
  }),
});

export type ActionCreateUserPermissionRequest = yup.InferType<
  typeof ActionCreateUserPermissionRequestSchema
>;

export const ActionDeleteUserPermissionRequestSchema = yup.object({
  action: yup
    .mixed<BulkUserPermissionAction>()
    .oneOf([BulkUserPermissionAction.DELETE]),
  path: yup.string(),
});

export type ActionDeleteUserPermissionRequest = yup.InferType<
  typeof ActionDeleteUserPermissionRequestSchema
>;
